export const adaptComplejidad = (complejidadData) => {
    return {
        id: complejidadData?.idComplejidad,
        displayName: complejidadData?.descripcion,
        name: complejidadData?.descripcion
    }
}

export const adaptComplejidadArray = (
    complejidades
) => {
    return structuredClone(complejidades?.allComplejidad)
        ?.map(complejidad => adaptComplejidad(complejidad));
}